<template>
  <section class="loan-meta">
    <div class="grid-container">
      <div class="grid-x grid-padding-x small-up-1 medium-up-4">
        <div v-for="item in items" :id="item.id" :key="item.value" class="loan-meta__item cell">
          <div class="grid-x">
            <div class="cell small-10 medium-12 medium-order-2">
              <p v-html="item.label" />
              <p class="h3" v-if="item.url === null" v-html="item.value" />
              <p v-if="item.url !== null">
                <nuxt-link :to="item.url" v-text="item.value" class="h3" />
              </p>
            </div>
            <div class="cell small-2 medium-12 medium-order-1 icon-cell">
              <font-awesome-icon :icon="item.icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import i18n from './locales'
  import { mapGetters } from 'vuex'
  import { money } from '~/utils/format'
  import { facActivityType } from '~/assets/font-awesome-custom/fac-activity-type'
  import { facAmountRequested } from '~/assets/font-awesome-custom/fac-amount-requested'
  import { facMfi } from '~/assets/font-awesome-custom/fac-mfi'
  import { facCalendar } from '~/assets/font-awesome-custom/fac-calendar'

  export default {
    name: 'LoanDetailsMeta',
    i18n,
    computed: {
      ...mapGetters({
        loan: 'loans/current',
      }),
      items () {
        return [
          {
            label: this.$t('amount'),
            value: money(this.loan.fundingAmount, this.loan.fundingCurrency),
            url: null,
            icon: ['fac', 'amount-requested'],
            id: 'loanMetaAmount',
          },
          {
            label: this.$t('term'),
            value: this.$t('termValue', { num: this.loan.term }),
            url: null,
            icon: ['fac', 'calendar'],
            id: 'loanMetaTerm',
          },
          {
            label: this.$t('activity'),
            value: this.$get(this.loan, 'activity', ''),
            url: null,
            icon: ['fac', 'activity-type'],
            id: 'loanMetaActivity',
          },
          {
            label: this.$t('mfi'),
            value: this.loan.entrepreneur.mfi.name,
            url: this.loan.entrepreneur.mfi.lwcUrl,
            icon: ['fac', 'mfi'],
            id: 'loanMetaMfi',
          },
        ]
      },
    },
    created () {
      this.$fa.add(facActivityType, facAmountRequested, facMfi, facCalendar)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~assets/scss/frontend/_settings";
  @import "~foundation-sites/scss/util/unit";
  @import "~foundation-sites/scss/util/value";
  @import "~foundation-sites/scss/util/breakpoint";

  .loan-meta {
    .loan-meta__item {
      border-bottom: $global-border;
      padding: {
        bottom: 1rem;
        top: 1rem;
      }

      @include breakpoint (medium) {
        text-align: center;
        border: {
          bottom: none;
          right: $global-border;
        }

        &:last-child {
          border-right: none;
        }
      }

      p {
        margin-bottom: 0;
      }

      .icon-cell {
        align-items: center;
        color: $colour-green;
        display: flex;
        justify-content: flex-end;

        @include breakpoint (medium) {
          justify-content: center;
        }

        svg {
          font-size: 2rem;

          @include breakpoint (medium) {
            font-size: 3.2rem;
            margin-bottom: 1rem;
          }
        }
      }
    }
  }
</style>
